module.exports = __webpack_public_path__ + "img/setup-donuts-dippen-in-kaneelsuiker.27b46cbb.jpg";